export const extraMessageErrorSendForSignature =
  'Suite à une indisponibilité technique, cette fonctionnalité n’est pas disponible. Merci de réessayer ultérieurement ou de retourner sur un processus d’envoi du dossier sans signature électronique.';
